import { Preferences } from "@capacitor/preferences";
import type { StorageAdapter } from "@lib/platform/storage";

export const capacitorPreferencesStorage: StorageAdapter = {
  async get(key) {
    const { value } = await Preferences.get({ key });
    return value;
  },
  async set(key, value) {
    await Preferences.set({ key, value });
  },
  async remove(key) {
    await Preferences.remove({ key });
  },
};
